'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function (child, component) {
  var children = child.props.children;
  if (child.props.children && typeof child.props.children !== 'string') children = component.renderChildren(child.props.children);
  return children;
}; //Helps recursively render the children